import { getText, TEXT_KEY } from '../../../utils/localization';
import { numberWithCommas } from '../../../utils/number';

/**
 * @param {Function} addNotification - The function to add the notification
 * @param {Number} rewardValue - The value of the reward
 */
export var showSuccessNotification = function showSuccessNotification(addNotification, rewardValue) {
  addNotification({
    title: getText(TEXT_KEY.BATTLES_COLLECT_CONGRATS),
    message: "".concat(getText(TEXT_KEY.REDEEM_MESSAGE_CONGRATS), " ").concat(numberWithCommas(rewardValue), " coins ").concat(getText(TEXT_KEY.REDEEM_MESSAGE_CONGRATS_TEXT)),
    button: getText(TEXT_KEY.OK),
    hideCloseButton: true,
    hideHelpButton: true
  });
};

/**
 * @param {Function} addNotification - The function to add the notification
 */
export var showErrorNotification = function showErrorNotification(addNotification) {
  addNotification({
    title: getText(TEXT_KEY.OOPS),
    message: getText(TEXT_KEY.DEFAULT_ERROR_MESSAGE),
    button: getText(TEXT_KEY.OK),
    hideCloseButton: true,
    hideHelpButton: true
  });
};